import styled from 'styled-components';

export const Matrix = styled.table`
  width: 100%;
  table-layout: fixed;
  font-size: 0.75rem;
  border-collapse: collapse;

  thead {
    tr {
      height: 216px;

      th {
        font-weight: normal;
        position: relative;
        padding-top: 250px;

        &:first-child {
          width: 200px;
        }

        &:nth-child(even) {
          background: #eee;
        }

        div {
          bottom: 0;
          position: absolute;
          white-space: nowrap;
          transform-origin: 0 50%;
          transform: translate(21px) rotate(-90deg);
        }
      }
    }
  }

  tbody {
    tr:nth-child(odd) {
      background: #eee;
    }

    td {
      text-align: right;
      padding: 4px;

      &:first-child {
        text-align: left;
      }

      &:nth-child(even) {
        background: #eee;
      }
    }
  }
`;
